import {
	$applyNodeReplacement, EditorConfig, LexicalNode,
	ParagraphNode
} from "lexical";

export class ExtendedParagraphNode extends ParagraphNode {
	static override getType(): string {
		return "extended-paragraph";
	}

	static override clone(node: ExtendedParagraphNode): ExtendedParagraphNode {
		return new ExtendedParagraphNode(node.__key);
	}

	override createDOM(_config: EditorConfig): HTMLElement {
		const dom = document.createElement("p");
		dom.setAttribute("style", "margin: 0; position: relative; word-break: break-word;");
		
		return dom;
	}
}

export function $createInlineParagraphNode(): ExtendedParagraphNode {
	return $applyNodeReplacement(new ExtendedParagraphNode());
}

export function $isExtendedParagraphNode(
	node: LexicalNode | null | undefined
): node is ExtendedParagraphNode {
	return node instanceof ExtendedParagraphNode;
}
